import React from 'react'
import { Link } from 'react-router-dom'

import { Grid, Box, makeStyles } from '@material-ui/core'
import MainImage from '../assets/no-project-found.svg'

const useStyles = makeStyles((theme) => ({
  mainBox: {
    marginTop: '3rem',
    backgroundColor: '#FFF',
    margin: '0 auto 7.5rem',
    [theme.breakpoints.up('lg')]: {
      margin: '4rem auto 17.625rem',
      maxWidth: 568,
    },
  },
  image: {
    display: 'block',
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    padding: '0 2rem',
  },
  section: {
    padding: '0 2rem',
    [theme.breakpoints.up('sm')]: {
      padding: '0 4rem',
    },
    [theme.breakpoints.up('md')]: {
      padding: '0 2rem',
    },
  },
  h2: {
    color: '#1E2553',
    fontSize: '1.75rem',
    margin: '1rem 0',
    [theme.breakpoints.up('lg')]: {
      fontSize: '2.5rem',
    },
  },
  text: {
    fontSize: '1.125rem',
  },
  jobBottom: {
    borderTop: '1px solid #EEE',
    display: 'flex',
    justifyContent: 'center',
    padding: '2rem',
    [theme.breakpoints.up('md')]: {},
  },
  jobDetails: {
    color: '#FFFFFF',
    cursor: 'pointer',
    backgroundColor: '#1E2553',
    padding: '0.5625rem 2.5rem',
    textAlign: 'center',
    textDecoration: 'none',
    width: '100%',
    textTransform: 'uppercase',
    '&:hover': {
      textDecoration: 'none',
    },
    [theme.breakpoints.up('md')]: {
      width: 'auto',
    },
    borderRadius: '3px',
    boxShadow: '0 2px 2px #70707066',
  },
}))

const NoActiveProjects = () => {
  const classes = useStyles()

  return (
    <Grid container>
      <Box className={classes.mainBox}>
        <Grid item>
          <img className={classes.image} alt="Drawing of Reader" src={MainImage} />
        </Grid>
        <Box className={classes.section}>
          <h2 className={classes.h2}>No Results Found</h2>
          <p className={classes.text}>
            Try entering a more broad search. Your filters might be too narrow or specific for
            projects.
          </p>
          <p>Try again or check out our FAQ page to learn more.</p>
        </Box>

        <Grid item xs={12} className={classes.jobBottom}>
          <Link to={'mailto:example@example.com'} className={classes.jobDetails}>
            learn more
          </Link>
        </Grid>
      </Box>
    </Grid>
  )
}

export default NoActiveProjects
